import { RootState } from "../../../app/store";

export const selectMe = (state: RootState) => state.me.user;
export const selectMyRole = (state: RootState) => state.me.user?.role;
export const selectMyCompanies = (state: RootState) => state.me.companies;
